import React from 'react';
import TemplatePage, { TemplateSection } from './TemplatePage';

// F10 (McKayla Loom "Current Site Feedback Part 2" t=3:47, ClickUp 86bah7dqn).
// Verbatim: "we need a page that says get help. So live chat is great. I think
// this is going to be hard to do right now because we don't have any employees
// or really the process set up. But I think eventually that needs to be an
// option."
//
// ⛔ DO NOT BUILD LIVE CHAT. She ruled it out in the same breath, with her
// reason — there is nobody to staff it. A chat widget nobody answers is worse
// than no chat widget. It is recorded here as a deliberate omission so a later
// agent does not read its absence as an oversight.
//
// No contact route is named yet either, so this page does not promise a
// response time or publish an address we have not agreed to monitor.
export default function GetHelp() {
  return (
    <TemplatePage
      title="Get help"
      intro="A placeholder for the support page. How support requests reach a person has not been decided yet, so nothing on this page promises a reply."
    >
      <TemplateSection
        heading="How to reach us"
        body="Placeholder — the support route (email, form, or phone) is not decided. Nothing is published here until it is."
      />
      <TemplateSection
        heading="Common problems"
        body="Placeholder for self-serve troubleshooting."
      />
      <TemplateSection
        heading="Live chat"
        body="Deliberately not built. McKayla ruled it out for now because there is nobody to staff it; she expects it eventually."
      />
    </TemplatePage>
  );
}
